import { useAuth } from '~/composables/useAuth';
export default defineNuxtRouteMiddleware(async (to) => {
  
  // We only care about auth on the client (SPA)
  if (!true || to.meta.auth === false) return;

  // Make sure state is loaded from localStorage & user is fetched if needed
  const auth = useAuth();
  
  const isAuthed = auth.isAuthenticated.value;

  // ---- 1) Guest-only routes (e.g. login, register) ----
  if (to.meta.auth?.unauthenticatedOnly) {
    if (isAuthed) {
      // Already logged in → bounce them away from login/register
      const redirect = (to.query.redirect) || to.meta.auth?.navigateAuthenticatedTo || '/'; //  as string
      return navigateTo(redirect);
    }
    // Not logged in → allowed
    return;
  }

  // Not logged in, remember intended page. 
  if (!isAuthed && to.path != '/auth/login') {
    const redirect = to.meta.auth?.navigateUnauthenticatedTo || `/auth/login?redirect=${encodeURIComponent(to.fullPath)}`; //  as string
    return navigateTo(redirect);
  }
  
  // Routes with permission restrictions
  const authStore = useAuthStore();
  if(to.meta.auth?.permissions &&
    to.meta.auth.permissions.length > 0 &&
    !authStore.user.hasPermissionIn(to.meta.auth.permissions)) {
    // User does not have permissions.
    throw createError({
      status: 403,
      statusText: "Sorry, you don't have access to this section of myLHS.",
      fatal: true,
      data: {
        permissions: to.meta.auth.permissions,
      }
    });
  }

  /*
  if (to.params.id === '1') {
    return abortNavigation()
  }
  // In a real app you would probably not redirect every route to `/`
  // however it is important to check `to.path` before redirecting or you
  // might get an infinite redirect loop
  if (to.path !== '/') {
    return navigateTo('/')
  }
  */
});
